import $ from 'jquery';

class AlertBanner {
    constructor () {
        this.$alertBannerButton = $('.js-alert-banner-button');
        this.$alertBanner       = $('.js-alert-banner');

        this.$cookieSaved = document.cookie.indexOf('alert') !== -1;

        if (this.$cookieSaved === false) {
            $(window).on('load', $.proxy(this.showAlert, this));
        }

        this.$alertBannerButton.on('click', $.proxy(this.closeAlert, this));
    }

    showAlert () {
        this.$alertBanner.slideDown(600);
    }

    closeAlert () {
        this.$alertBanner.slideUp(600);
        this.setCookie();
        this.$cookieSaved = true;
    }

    // eslint-disable-next-line class-methods-use-this
    setCookie () {
        const date = new Date();

        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));

        const expires = `; expires=${date.toUTCString()}`;

        document.cookie = `alert=hide${expires}; path=/`;
    }
}

export default AlertBanner;
